import { Injectable, TemplateRef } from '@angular/core';
import { CloudNotificationStyle } from '../models/cloud-notification-style.model';
import { ToastNotification } from '../models/toast-notification.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { GetNotifications } from '../interfaces/services/notification.interface';
import { CloudNotificationResponse } from '../models/cloud-notification-response.model';
import { HttpService } from '../http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CloudNotificationService implements GetNotifications {
  panelDisplayStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);

  toasts: ToastNotification[] = [];
  notificationCount = 0;
  notificationCountSubject = new BehaviorSubject<number>(0);

  constructor(private http: HttpService) {
    this.notificationCountSubject.subscribe(count => {
      this.notificationCount = count;
    });
  }

  readNotification(notifications: CloudNotificationResponse[]): Observable<any> {
    return this.http.put(environment.api.routes.read_notifications, notifications.filter(x => !x.isRead).map(x => x.id));
  }
  dismissAll(notifications: CloudNotificationResponse[]): Observable<any> {
    return this.http.put(environment.api.routes.dismiss_notifications, notifications.map(x => x.id));
  }

  createToastNotification(id: string, body: string | TemplateRef<any>, style: CloudNotificationStyle, toastDelay = environment.admin.toast_delay) {
    this.removeToastNotification(id);
    switch (style) {
      case CloudNotificationStyle.success:
        this.toasts.push({
          id,
          body,
          className: 'bg-success text-light',
          delay : toastDelay
        });
        break;
      case CloudNotificationStyle.warning:
        this.toasts.push({
          id,
          body,
          className: 'bg-warning text-dark',
          delay:toastDelay
        });
        break;
      case CloudNotificationStyle.danger:
        this.toasts.push({
          id,
          body,
          className: 'bg-danger text-light',
          delay : toastDelay
        });
        break;
      case CloudNotificationStyle.info:
        this.toasts.push({
          id,
          body,
          className: 'bg-primary text-light',
          delay : toastDelay
        });
        break;
    }
  }

  createorUpdateToastNotification(id: string, body: string | TemplateRef<any>, style: CloudNotificationStyle) {
    const createdToast = this.toasts.filter(toast => toast.id === id)[0];
    if (!createdToast) {
      this.createToastNotification(id, body, style);
      return;
    }
    const existingToast = this.toasts.filter(toast => toast.id === id)[0];
    existingToast.body = body;
    switch (style) {
      case CloudNotificationStyle.success:
        existingToast.className = 'bg-success text-light';
        break;
      case CloudNotificationStyle.warning:
        existingToast.className = 'bg-warning text-dark';
        break;
      case CloudNotificationStyle.danger:
        existingToast.className = 'bg-danger text-light';
        break;
      case CloudNotificationStyle.info:
        existingToast.className = 'bg-primary text-light';
        break;
    }
    this.toasts = this.toasts.filter(toast => toast.id !== id);
    this.toasts.push(existingToast);
  }

  remove(toast: ToastNotification) {
    this.toasts = this.toasts.filter(t => t.id !== toast.id);
  }

  removeToastNotification(id: string) {
    this.toasts = this.toasts.filter(t => t.id !== id);
  }

  // implementations

  getNotifications(): Observable<CloudNotificationResponse[]> {
    return this.http.get(environment.api.routes.get_notifications);
  }
}
